import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const mobileDrawer = css`
  background-color: ${cssTheme.colors.warmGray[100].hex};
`

export const fullScreen = css`
  inset-block-start: 0;
`

export const mobileDrawerBody = css`
  position: relative;
  background: transparent;

  & > *:not(:last-child) {
    block-size: unset;
    margin-block-end: ${spacing(0.75)};
  }
`

export const captionText = css`
  opacity: 0.5;
`
